import { alpha, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Backdrop(theme: Theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[800], theme.palette.mode === 'light' ? 0.56 : 0.62),
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
